<script setup lang="ts">
import type { NuxtError } from '#app';

const { t } = useI18n();

interface Props {
  error: NuxtError;
}

const props = defineProps<Props>();

useHead({
  title: props.error.message || 'Error',
  meta: [
    {
      name: 'description',
      content: props.error.message || 'An error occurred',
    },
  ],
});

const localePath = useLocalePath();

const errorImage = computed<string>(() => {
  switch (props.error.statusCode) {
    case 404:
      return '/errors/error-404.svg';
    case 500:
      return '500 image path';
    case 403:
      return '/errors/error-403.svg';
    default:
      return '404 image path';
  }
});

const handleClearError = (): void => {
  clearError({
    redirect: localePath('/')
  });
};
</script>

<template>
  <template v-if="error.statusCode === 404">
    <ErrorViews404 @handleClearError="handleClearError" :image-path="errorImage" />
  </template>
  <template v-if="error.statusCode === 403">
    <ErrorViews403 @handleClearError="handleClearError" :image-path="errorImage" />
  </template>
  <template v-else-if="error.statusCode !== 404 && error.statusCode !== 403">
    <div class="flex flex-col items-center justify-center h-screen">
      <div class="font-bold text-[50px]">{{ error.statusCode }}</div>
      <div class="font-semibold text-lg mb-3">{{ error.message }}</div>
      <UButton @click="handleClearError" size="xl">
        {{ t('label.back_to_home') }}
      </UButton>
    </div>
  </template>
</template>
